const displayModeEnum = Object.freeze({
    LTR: 5,
    RTL: 10
});
export default displayModeEnum;
